import React from 'react';

import { PrimaryFilters as PrimaryFiltersProvider } from 'components/Filters';

import {
  FILTER_REGISTRATION_PERIOD,
  FILTER_APPLICATIONS,
  FILTER_NETWORKS,
  FILTER_PLATFORMS,
  FILTER_AFFILIATES,
  FILTER_REAL_COUNTRIES,
} from 'scenes/RegsStats/constants';

import Filters from './filters';

export const PRIMARY_FILTERS = [
  FILTER_REGISTRATION_PERIOD,
  FILTER_APPLICATIONS,
  FILTER_NETWORKS,
  FILTER_PLATFORMS,
  FILTER_AFFILIATES,
  FILTER_REAL_COUNTRIES,
];

const PrimaryFilters = () => {
  return (
    <PrimaryFiltersProvider primary={PRIMARY_FILTERS}>
      <Filters.RegistrationPeriod />
      <Filters.Applications />
      <Filters.Networks />
      <Filters.Platforms />
      <Filters.Affiliates />
      <Filters.RealCountries />
    </PrimaryFiltersProvider>
  );
};

export default PrimaryFilters;
